import { render, staticRenderFns } from "./StandRadioGroup.vue?vue&type=template&id=8b720558&"
import script from "./StandRadioGroup.vue?vue&type=script&lang=js&"
export * from "./StandRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports